import { LibraryCreatedProductOut, LibraryCreatedProductRequest } from '../../../../store/apiLibx';
import isNil from 'lodash/isNil';
import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';

const url = `${localContentPrefix}/v1/localcontent/products/:id?`;
export const uploadLocalContentProduct = (product: LibraryCreatedProductRequest & { id?: string }) => {
    const isNew = isNil(product.id);

    const params = {};
    if (!isNew) {
        params['pathParams'] = { id: product.id };
    }

    return http.post<LibraryCreatedProductOut>(url, product, params).then(response => product.id ?? response.data.id!);
};
